import { default as API } from './api';
import { auth } from './firebase';

import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { default as SESSION_ACTIONS } from './reducers/session';
import { default as UI_ACTIONS } from './reducers/ui';

import ContextProvider from './context';

import AppPrivate from './private/app';
import AppPublic from './public/app';

import Spinner from './components/ui/spinner';
import Toast from './components/ui/feedback';
import './styles/index.css';

let defaultPala = {
  id: 0,
  style: 'Control',
  brand: 'Adidas',
  nickname: 'Zuckur',
};

let sponsoredPala = {
  id: 1,
  style: 'Attack',
  brand: 'Bullpadell',
  nickname: 'Vertex 20 confort',
  sponsored: true,
};

let defaultLevelNewUser = 2;

function App({ notifyUser, isLoading = true, success, ...otherProps }) {
  const { authed, booting, unNotifyUser, notifications } = otherProps;

  useEffect(() => {
    let listener;
    let firstTry = true;

    async function firstLoad() {
      try {
        isLoading(true);
        listener = auth.onAuthStateChanged(async user => {
          if (user) {
            await API.getUserProfile(user.uid).then(profile => {
              if (!profile.exists) {
                //---- new user without profile, prepopulate once ----//
                let player = {
                  sessionId: user.uid,
                  email: user.email,
                  nick: user.email.replace(/@[^@]+$/, ''),
                  signup: new Date(),
                  palas: [defaultPala, sponsoredPala],
                  level: defaultLevelNewUser,
                };
                API.createUserProfile(user.uid, player).then(_ => {
                  //---- pass response to redux  ----//
                  success(player, []);
                });
              } else {
                //---- user has a profile, fetch games ----//
                const {
                  sessionId,
                  email,
                  nick,
                  signup,
                  palas,
                  level,
                } = profile.data();

                let games = [];
                API.getCollection(user.uid).then(querySnapshot => {
                  querySnapshot.forEach(doc => {
                    const {
                      courtSide,
                      players,
                      victory,
                      duration,
                      month,
                      mvp,
                      pala,
                      updated,
                    } = doc.data();
                    games.push({
                      key: doc.id,
                      courtSide,
                      players,
                      victory,
                      duration,
                      month,
                      mvp,
                      pala,
                      updated,
                    });
                  });
                  //---- pass response to redux  ----//
                  success(
                    { sessionId, email, nick, signup, palas, level },
                    games,
                  );
                });
              }
            });
          } else {
            //---- user has not authed before or has clicked to log out ----//
            // console.log('danger will robinson');
            isLoading(false);
          }
        }); //-- end auth change listener
      } catch (o_O) {
        notifyUser(o_O.code, 'sticky', 'fail');
      }
    }
    if (firstTry) {
      firstLoad();
      firstTry = false;
    }
    return () => {
      listener = null;
    };
  }, []);

  return (
    <ContextProvider>
      {notifications.length > 0 &&
        notifications.map(n => (
          <Toast key={n.id} {...n} cb={uid => unNotifyUser(uid)} />
        ))}

      {booting ? (
        <Spinner color="var(--highlight)" />
      ) : authed ? (
        <AppPrivate />
      ) : (
        <AppPublic />
      )}
    </ContextProvider>
  );
}

const select = state => {
  return {
    booting: state.session.booting,
    notifications: state.ui.notifications,
    authed: state.session.authed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    success: (user, games) => dispatch(SESSION_ACTIONS.success(user, games)),
    isLoading: bool => dispatch(SESSION_ACTIONS.boot(bool)),
    notifyUser: msg => dispatch(UI_ACTIONS.showFeedback(msg)),
    unNotifyUser: id => dispatch(UI_ACTIONS.dissmissFeedback(id)),
  };
};
export default connect(select, mapDispatchToProps)(App);
